import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Router from './Router';
import { ErrorBoundary } from './components/ErrorBoundary';

// Clear chunk-reload guard after a successful load.
sessionStorage.removeItem('nls-chunk-reload');

// Dev: unregister legacy service workers that cached stale JS chunks.
if (process.env.NODE_ENV !== 'production' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => r.unregister());
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <ErrorBoundary>
    <Router />
  </ErrorBoundary>
);
